import { hotList } from '@/mocks/hotList';
import SectionHeading from '@/components/feature/SectionHeading';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestSection() {
  const feed = hotList.slice(3);

  return (
    <section className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="LATEST FEED"
          title="最新速报，正在滚动的瓜"
          description="按时间流整理的单个事件进展，适合想知道「后来又怎么样了」的你。"
          actionLabel="按热度查看"
          actionTo="/ranking"
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {feed.map((item) => (
            <ArticleCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}